/** Local library SetNext capability gate (#1137) — kept out of connectorCapability.ts for size baseline. */
import { connectorMeetsMinVersion, getConnectorVersion } from './connectorVersion';

export const MIN_LOCAL_LIBRARY_SETNEXT_CONNECTOR = '11.0.324';

export function connectorSupportsLocalLibrarySetNext(): boolean {
  if (typeof window === 'undefined') return false;
  type W = Window & { __MAESTRO_CONNECTOR__?: { capabilities?: { local_library_setnext?: boolean } } };
  const info = (window as W).__MAESTRO_CONNECTOR__;
  const flag = info?.capabilities?.local_library_setnext;
  if (flag === true) return true;
  if (flag === false) return false;
  return connectorMeetsMinVersion(getConnectorVersion(), MIN_LOCAL_LIBRARY_SETNEXT_CONNECTOR);
}
